import { HomeIcon } from '../../Brand/Icon';
import React from "react";
import { APP_ROUTES } from '../../../utils/constant';
import url from '../../../utils/url';
import { AnimatedLink } from '../AnimatedLink';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export default function ButtonHome() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
      <AnimatedLink aria-label={t('common.home', { defaultValue: 'Home' })} to={url(`${APP_ROUTES.MAIN}`)}
        onClick={event => {
          if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          navigate(url(APP_ROUTES.MAIN), { state: { feedRefresh: Date.now() } });
        }}>
        <HomeIcon className="nav-icon" />
      </AnimatedLink >
  )
}
